import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { SymptomsChecklist } from '../components/SymptomsChecklist';
import { WhyMedicineFails } from '../components/WhyMedicineFails';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { ProductIntroduction } from '../components/ProductIntroduction';
import { BonusStack } from '../components/BonusStack';
import { ValueStackTable } from '../components/ValueStackTable';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { UrgencyBlock } from '../components/UrgencyBlock';
import { FinalCTA } from '../components/FinalCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export const LandingPage = () => {
  return <>
      <AnnouncementBar data-id="element-282" />
      <HeroSection data-id="element-283" />
      <StorySection data-id="element-284" />
      <SymptomsChecklist data-id="element-285" />
      <WhyMedicineFails data-id="element-286" />
      <UniqueMechanism data-id="element-287" />
      <ProductIntroduction data-id="element-288" />
      <BonusStack data-id="element-289" />
      <ValueStackTable data-id="element-290" />
      <Testimonials data-id="element-291" />
      <Guarantee data-id="element-292" />
      <UrgencyBlock data-id="element-293" />
      <FinalCTA data-id="element-294" />
      <FAQ data-id="element-295" />
      <Footer data-id="element-296" />
    </>;
};